<!-- eslint-disable vue/v-on-event-hyphenation -->
<template>
  <div
    class="mt-3 mb-3 d-flex align-items-center justify-content-between flex-wrap gap-5 flex-grow-1"
  >
    <div class="d-flex align-items-center gap-3 flex-wrap multi-select-parent">
      <!-- <button
        v-if="!hasLoadedAllHistory"
        class="btn btn-primary"
        @click="$emit('loadAllHistoricalSurveys')"
      >
        <i class="bi bi-arrow-left"></i>
        Load more
      </button> -->
      <PulsMultiSelect
        v-if="shouldDisplaySurveySelector"
        id="survey-selector"
        ref="surveySelector"
        :disabled="disabled"
        :options="surveysForSelector"
        :onSelectOption="onSelectSurvey"
        :selectedOption="selectedSurvey"
        :isSearchable="surveysForSelector.length > 10"
        :placeholder="$t('results.chooseSurvey')"
        :label="$t('utilityBar.survey')"
      >
        <template #button>
          <div class="d-flex justify-content-center">
            <button
              v-if="!hasLoadedAllHistory"
              class="btn btn-sm btn-secondary my-2"
              @click="loadMoreSurveys"
            >
              {{ $t('groupsComparison.loadMore') }}
            </button>
          </div>
        </template>
      </PulsMultiSelect>
      <PulsMultiSelect
        v-if="shouldDisplayGroupSelector"
        :disabled="disabled"
        :options="groupsForSelector"
        :onSelectOption="onSelectGroup"
        :selectedOption="selectedGroup"
        :isSearchable="groupsForSelector.length > 10"
        :placeholder="$t('groupsComparison.filter.findGroups')"
        :label="$t('utilityBar.group')"
      />
      <PulsMultiSelect
        v-if="!shouldDisplayGroupSelector"
        :disabled="true"
        :selectedOption="{
          name: 'all-groups',
          title: $t('utilityBar.allGroups')
        }"
        :title="$t('utilityBar.cannotChangeGroupsWhileComparing')"
        data-bs-toggle="tooltip"
        :data-bs-placement="'bottom'"
        :label="$t('utilityBar.group')"
      />
      <PulsMultiSelect
        v-if="shouldDisplayAttributeSegmentSelector"
        :disabled="disabled"
        :options="attributeSegmentsForSelector"
        :onSelectOption="onSelectAttributeSegment"
        :selectedOption="selectedAttributeSegment"
        :label="$t('utilityBar.segment')"
      />
    </div>
    <div class="d-flex justify-content-end align-items-center flex-wrap">
      <HistorySelector
        v-if="hasHistory && !allHistoryIsAvailableAsDefault"
        :disabled="disabled"
        :selectedTimePeriod="selectedTimePeriod"
        :surveyDetails="surveyDetails"
        @timePeriodSelected="setSelectedTimePeriod"
      />
    </div>
  </div>
</template>

<script>
import PulsMultiSelect from '@/components/shared/puls-multi-select/PulsMultiSelect.vue'
import HistorySelector from '@/components/results/subcomponents/HistorySelector.vue'
import { tabTypes } from '@/constants/tab-types'

export default {
  name: 'UtilityBar',
  components: {
    PulsMultiSelect,
    HistorySelector
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    hasLoadedAllHistory: {
      type: Boolean,
      required: true
    },
    surveysForSelector: {
      type: Array,
      required: true
    },
    groupsForSelector: {
      type: Array,
      required: true
    },
    selectedSurvey: {
      type: Object,
      required: true
    },
    selectedGroup: {
      type: Object,
      required: true
    },
    attributeSegmentsForSelector: {
      type: Array,
      required: true
    },
    selectedAttributeSegment: {
      type: Object,
      required: true
    },
    selectedTab: {
      type: String,
      required: true
    },
    surveyDetails: {
      type: Object,
      required: true
    },
    selectedTimePeriod: {
      type: String,
      required: true
    },
    userIsAdminForCurrentGroup: {
      type: Boolean,
      required: true
    }
  },
  emits: [
    'goToResults',
    'selectSurvey',
    'selectGroup',
    'selectAttributeSegment',
    'setSelectedTimePeriod',
    'changeViewMode',
    'toggleNotes',
    'loadAllHistoricalSurveys'
  ],
  computed: {
    isComparisonTab() {
      return this.selectedTab === tabTypes.COMPARISON
    },
    hasHistory() {
      return this.surveyDetails?.oldSurveys?.length > 0
    },
    shouldDisplaySurveySelector() {
      return true
    },
    shouldDisplayGroupSelector() {
      return !this.isComparisonTab
    },
    shouldDisplayAttributeSegmentSelector() {
      const hasMoreThanOneAttributeConfigured =
        this.attributeSegmentsForSelector.length > 1

      const isLookingAtEntireOrganization = !Object.keys(
        this.selectedGroup
      ).includes('numberOfUsers')

      const selectedGroupHasMultipleUsers =
        this.selectedGroup?.numberOfUsers > 1

      if (isLookingAtEntireOrganization) {
        return hasMoreThanOneAttributeConfigured
      } else {
        return (
          hasMoreThanOneAttributeConfigured && selectedGroupHasMultipleUsers
        )
      }
    },
    allHistoryIsAvailableAsDefault() {
      // TODO: Decide on default amount of surveys to load history for
      return false
      // return (
      //   this.surveyDetails?.oldSurveys?.length ===
      //   this.resultsStore.currentlyLoadedSurveys.length
      // )
    }
  },
  methods: {
    loadMoreSurveys() {
      this.$emit('loadAllHistoricalSurveys')
      this.$refs.surveySelector.closeDropdown()
    },
    onSelectSurvey(survey) {
      this.$emit('selectSurvey', survey)
    },
    onSelectGroup(group) {
      this.$emit('selectGroup', group)
    },
    onSelectAttributeSegment(segment) {
      this.$emit('selectAttributeSegment', segment)
    },
    setSelectedTimePeriod(timePeriod) {
      this.$emit('setSelectedTimePeriod', timePeriod)
    }
  }
}
</script>
